import { Target, TypedController, Value } from "@vytant/stimulus-decorators";
import { addSeconds, formatDistanceStrict } from "date-fns";
import { de, enGB, fr, nlBE } from "date-fns/locale";
import { Controller } from "stimulus";

@TypedController
export default class extends Controller {
  @Target readonly passwordInputTarget: HTMLInputElement;
  @Target readonly sendMagicLinkButtonTarget: HTMLButtonElement;
  @Target readonly submitButtonTarget!: HTMLButtonElement;
  @Target readonly remainingTimeLockedMessageTarget: HTMLElement;

  @Value(String) secondsRemainingLockedValue: number;
  @Value(String) currentLanguageValue: string;

  connect() {
    // technically this isn't needed, since all browser and extensions are covered by just listening on `input`
    // but just to be sure...
    ["input", "change", "blur"].forEach((event) => {
      this.passwordInputTarget.addEventListener(event, (e) => {
        this.updateSubmitButtonVisibility();
      });
    });

    // so firefox SOMETIMES fires only blur, sometimes doesn't do shit, so this is the only way to make it "consistently" work in firefox
    // screw you firefox...
    this.updateSubmitButtonVisibility();
    let i = 0;
    const interval = setInterval(() => {
      this.updateSubmitButtonVisibility();

      // 50ms * 20 -> 1s
      if (i++ > 20) {
        clearInterval(interval);
      }
    }, 50);

    // @ts-ignore StimulusDecorators default values are broken 🙄
    if (this.secondsRemainingLockedValue === "") this.secondsRemainingLockedValue = 0;
    if (this.currentLanguageValue === "") this.currentLanguageValue = "de";

    if (this.secondsRemainingLockedValue > 0) {
      this.disablePasswordInputAndCountdown();
    }
  }

  updateSubmitButtonVisibility() {
    this.submitButtonTarget.disabled = !this.passwordInputTarget.value;
  }

  disablePasswordInputAndCountdown() {
    this.setRemainingTimeLockedMessage();

    const interval = setInterval(() => {
      this.secondsRemainingLockedValue = this.secondsRemainingLockedValue - 1;

      if (this.secondsRemainingLockedValue <= 0) {
        clearInterval(interval);

        this.passwordInputTarget.disabled = false;
        this.sendMagicLinkButtonTarget.disabled = false;
        this.remainingTimeLockedMessageTarget.classList.add("hidden");
      }

      this.setRemainingTimeLockedMessage();
    }, 1000);
  }

  setRemainingTimeLockedMessage() {
    const timeSpan = this.remainingTimeLockedMessageTarget.querySelector("#remaining-time");

    const time = addSeconds(new Date(), this.secondsRemainingLockedValue);
    timeSpan!.innerHTML = formatDistanceStrict(new Date(), time, { locale: this.dateFnsLocale(this.currentLanguageValue) });
  }

  dateFnsLocale(lang: string) {
    switch (lang) {
      case "de":
        return de;
      case "en":
        return enGB;
      case "fr":
        return fr;
      case "nl":
        return nlBE;
      default:
        return de;
    }
  }
}
